import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DisplayText } from '@shopify/polaris'
import styled from 'styled-components'

const TextContainer = styled.div`
  ${props => props.color ? `color: ${props.color};` : ''}
  line-height: normal;
  width: 100%;
  ${props => props.containerStyle}

  & > p {
    ${props => props.styleRaw}
  }
`

class Text extends Component {

  render () {
    const { size, color, containerStyle, styleRaw } = this.props
    return (
      <TextContainer color={color} containerStyle={containerStyle} styleRaw={styleRaw}>
        <DisplayText size={size}>
          {this.props.children}
        </DisplayText>
      </TextContainer>
    )
  }
}

Text.defaultProps = {
  size: 'default',
  containerStyle: ''
}

Text.propTypes = {
  size: PropTypes.oneOf(['default', 'small', 'medium', 'large', 'extraLarge']),
  color: PropTypes.string,
  containerStyle: PropTypes.string,
  styleRaw: PropTypes.string
}

export default Text



// WEBPACK FOOTER //
// ./src/components/common/Text.js